import CalendarDelete from "./SVG/calendar-disable-1.svg?react";

const CalendarDeleteIcon = () => {
  return <CalendarDelete />;
};

export default CalendarDeleteIcon;
